// import html
import template from './locations-selector-component.hogan.html';

// js
import { HtmlComponent } from './../../html-component';
import { TextComponent } from './../../text/text-component';
import { EditableTextComponent } from './../../text/editable-text-component';
import { IconComponent } from './../../icons/icon/icon-component';
import { ToggleComponent } from './../../toggle/toggle-component';
import { DataLocationFilterParameters } from './../../../../data-management/data-filters/filters/data-location-filter';
import {
    SelectLocationCommandExecutor,
    SelectLocationCommandOutputParameters,
    SelectLocationCommandInputParameters
} from './../../../commands/select-location-command-executor';

import { LocationsSelectorGroupComponent } from './../locations-selector-group-component';

export class LocationsSelectorComponent extends HtmlComponent {
    private kmText: EditableTextComponent;
    private locText: TextComponent;
    private amount: TextComponent;
    private toggle: ToggleComponent;
    private icon: IconComponent;
    private enabled: boolean = true;
    private circle: { kilometers: number; lat: number; lng: number };

    constructor(
        private selectLocationCommandExecutor: SelectLocationCommandExecutor,
        private group: LocationsSelectorGroupComponent
    ) {
        super(template, {});

        this.toggle = new ToggleComponent({});
        this.toggle.addToParent(this);
        this.amount = new TextComponent({ text: '', extraClass: 'locations-selector-amount' });
        this.amount.addToParent(this);
        this.icon = new IconComponent({ iconname: 'circle thin' });
        this.icon.addToParent(this);
        this.kmText = new EditableTextComponent({
            suffixLabel: 'km',
            text: ' ... ',
            extraClass: 'locations-selector-info',
            prefixLabel: '',
            name: 'kilometers'
        });
        this.kmText.addToParent(this);

        this.locText = new TextComponent({ text: ' ...', extraClass: 'locations-selector-info' });
        this.locText.addToParent(this);
        this.initInteractivity();
        this.subscribeOnCommandUpdates();
    }

    private handleFilterUpdate(parameters: SelectLocationCommandOutputParameters) {
        this.amount.setText(parameters.filter.filteredData.length.toString());
        this.kmText.setText(parameters.circle.kilometers.toString());

        this.circle = parameters.circle;
    }

    private handleFilterDelete() {
        this.group.remove(this);
    }

    private subscribeOnCommandUpdates() {
        this.selectLocationCommandExecutor.commandExecuted.attach((parameters: SelectLocationCommandOutputParameters) =>
            this.handleFilterUpdate(parameters)
        );
        this.selectLocationCommandExecutor.deleted.attach(() => this.handleFilterDelete());
    }

    private initInteractivity() {
        this.toggle.change.attach((s: string) => {
            if (s === 'disabled') {
                this.disable();
            } else if (s === 'enabled') {
                this.enable();
            }
            this.selectLocationCommandExecutor.requestExecute(this.getFilterParameters());
        });

        this.kmText.change.attach((s: string) => {
            let km = parseFloat(s);
            this.circle.kilometers = km;
            this.selectLocationCommandExecutor.requestExecute(this.getFilterParameters());
        });
    }

    private enable() {
        this.amount.enable();
        this.kmText.enable();
        this.locText.enable();
        this.enabled = true;
    }

    private disable() {
        this.amount.disable();
        this.kmText.disable();
        this.locText.disable();
        this.enabled = false;
    }

    public getFilterParameters(): SelectLocationCommandInputParameters {
        return {
            enabled: this.enabled,
            circle: this.circle,
            circleOL: null
        };
    }
}
